<template>
  <section class="match-signup-info-section">
    <img class="signup-info-title" :src="infoData.titleImage" alt="赛事信息" />
    <img class="signup-info-title-mobile" :src="infoData.mobileTitleImage || infoData.titleImage" alt="赛事信息" />

    <div class="signup-info-board">
      <img class="signup-info-board-image" :src="infoData.boardImage" alt="赛事信息" />
      <div ref="coverSwiper" class="swiper signup-info-cover-swiper">
        <div class="swiper-wrapper">
          <div v-for="(cover, index) in infoData.coverImages" :key="`${cover}-${index}`" class="swiper-slide">
            <img class="signup-info-cover" :src="cover" alt="赛事海报" />
          </div>
        </div>

        <div
          v-if="infoData.coverImages.length > 1"
          class="signup-info-pagination"
          aria-hidden="true"
        >
          <div
            v-for="(_, index) in infoData.coverImages"
            :key="index"
            class="signup-info-pagination-bullet"
            :class="{ active: currentIndex === index }"
            @click="slideTo(index)"
          ></div>
        </div>
      </div>

      <div class="signup-info-copy">
        <article v-for="item in infoData.items" :key="item.title">
          <h3>{{ item.title }}</h3>
          <p>{{ item.content }}</p>
        </article>
      </div>
    </div>

    <div class="signup-info-mobile-layout">
      <div class="signup-info-mobile-visual">
        <div ref="mobileCoverSwiper" class="swiper signup-info-mobile-cover-swiper">
          <div class="swiper-wrapper">
            <div v-for="(cover, index) in mobileCoverImages" :key="`${cover}-${index}-mobile`" class="swiper-slide">
              <img class="signup-info-mobile-cover" :src="cover" alt="赛事海报" />
            </div>
          </div>

          <div
            v-if="mobileCoverImages.length > 1"
            class="signup-info-mobile-pagination"
            aria-hidden="true"
          >
            <div
              v-for="(_, index) in mobileCoverImages"
              :key="index"
              class="signup-info-mobile-pagination-bullet"
              :class="{ active: currentIndex === index }"
              @click="slideTo(index)"
            ></div>
          </div>
        </div>
      </div>

      <div class="signup-info-mobile-copy">
        <article v-for="item in infoData.items" :key="`${item.title}-mobile`">
          <h3>{{ item.title }}</h3>
          <p>{{ item.content }}</p>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'MatchSignupInfoSection',
  props: {
    infoData: { type: Object, required: true },
  },
  data() {
    return { currentIndex: 0, swiperInstance: null, swiperMode: null }
  },
  computed: {
    mobileCoverImages() {
      const [firstCover, ...remainingCovers] = this.infoData.coverImages
      return [this.infoData.mobileCoverImage || firstCover, ...remainingCovers]
    },
  },
  mounted() {
    this.$nextTick(() => this.initSwiper())
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    if (this.swiperInstance) this.swiperInstance.destroy(true, true)
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    initSwiper() {
      const isMobile = window.innerWidth <= 750
      const swiperRef = isMobile ? 'mobileCoverSwiper' : 'coverSwiper'
      if (!window.Swiper || !this.$refs[swiperRef]) return
      const vm = this
      this.swiperMode = isMobile ? 'mobile' : 'desktop'
      this.swiperInstance = new window.Swiper(this.$refs[swiperRef], {
        observer: true,
        observeParents: true,
        on: {
          slideChange() {
            vm.currentIndex = this.realIndex === undefined ? this.activeIndex : this.realIndex
          },
        },
      })
    },
    slideTo(index) {
      if (this.swiperInstance) this.swiperInstance.slideTo(index)
    },
    handleResize() {
      const nextMode = window.innerWidth <= 750 ? 'mobile' : 'desktop'
      if (this.swiperMode === nextMode) return
      if (this.swiperInstance) this.swiperInstance.destroy(true, true)
      this.swiperInstance = null
      this.$nextTick(() => this.initSwiper())
    },
  },
}
</script>

<style scoped lang="scss">
.match-signup-info-section {
  width: 10rem;
  margin: 0.526042rem auto 0;
  padding-bottom: 0.989583rem;

  .signup-info-title-mobile,
  .signup-info-mobile-layout {
    display: none;
  }

  .signup-info-title {
    display: block;
    width: 5.729167rem;
    height: 1.114583rem;
    margin: 0 auto;
  }

  .signup-info-board {
    position: relative;
    width: 7.291667rem;
    height: 3.822917rem;
    margin: 0.239583rem auto 0;

    .signup-info-board-image {
      display: block;
      width: 7.291667rem;
      height: 3.822917rem;
    }

    .signup-info-cover-swiper {
      position: absolute;
      top: 0.286458rem;
      left: 0.479167rem;
      width: 3.380208rem;
      height: 3.244792rem;
      border-radius: 0.1875rem;
      overflow: hidden;

      .signup-info-pagination {
        position: absolute;
        right: 0.151042rem;
        bottom: 0.104167rem;
        z-index: 3;
        display: flex;
        gap: 0.041667rem;
        align-items: center;

        .signup-info-pagination-bullet {
          display: block;
          width: 0.052083rem;
          height: 0.052083rem;
          border-radius: 0.104167rem;
          background: rgba(255, 255, 255, 0.75);
          cursor: pointer;
          transition: all 0.2s ease;

          &.active {
            width: 0.083333rem;
            height: 0.052083rem;
            background: #ffffff;
          }
        }
      }
    }

    .signup-info-cover {
      display: block;
      width: 3.380208rem;
      height: 3.244792rem;
      border-radius: 0.1875rem;
      object-fit: cover;
    }

    .signup-info-copy {
      position: absolute;
      top: 0.614583rem;
      left: 4.135417rem;
      width: 2.59375rem;
    }

    article + article {
      margin-top: 0.151042rem;
    }

    h3 {
      position: relative;
      height: 0.197917rem;
      margin: 0 0 0.145833rem;
      color: #000000;
      font-size: 0.125rem;
      font-weight: 700;
      line-height: 0.197917rem;

      &::before {
        position: absolute;
        top: 0.072917rem;
        left: -0.088542rem;
        width: 0.036458rem;
        height: 0.036458rem;
        background: #502525;
        content: '';
        transform: rotate(45deg);
      }
    }

    p {
      width: 2.59375rem;
      height: 0.791667rem;
      margin: 0;
      color: #000000;
      font-size: 0.09375rem;
      line-height: 0.197917rem;
    }
  }
}

@media (max-width: 750px) {
  .match-signup-info-section {
    width: 100%;
    margin: 0;
    padding-bottom: 1.653333rem;

    .signup-info-title {
      display: none;
    }

    .signup-info-title-mobile {
      display: block;
      width: 9.333333rem;
      height: 1.813333rem;
      margin: 0 auto;
    }

    .signup-info-board {
      display: none;
    }

    .signup-info-mobile-layout {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 9.413333rem;
      margin: 0.986667rem auto 0;
    }

    .signup-info-mobile-visual {
      width: 4.635707rem;
      height: 4.45rem;
      border-radius: 0.186667rem;
      overflow: hidden;
      flex: none;
    }

    .signup-info-mobile-cover-swiper {
      position: relative;
      width: 100%;
      height: 100%;
    }

    .signup-info-mobile-cover {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .signup-info-mobile-pagination {
      position: absolute;
      right: 0.15rem;
      bottom: 0.1rem;
      z-index: 3;
      display: flex;
      gap: 0.106667rem;
      align-items: center;
    }

    .signup-info-mobile-pagination-bullet {
      display: block;
      width: 0.07144rem;
      height: 0.07144rem;
      border-radius: 0.533333rem;
      background: #767676;
      cursor: pointer;

      &.active {
        width: 0.114293rem;
        height: 0.07144rem;
        background: #ffffff;
      }
    }

    .signup-info-mobile-copy {
      width: 4.453333rem;

      article + article {
        margin-top: 0.346667rem;
      }

      h3 {
        margin: 0 0 0.186667rem;
        color: #000000;
        font-size: 0.32rem;
        font-weight: 700;
        line-height: 0.32rem;
      }

      p {
        margin: 0;
        color: #000000;
        font-size: 0.266667rem;
        line-height: 0.373333rem;
      }
    }
  }
}
</style>
